import React, { useCallback } from "react";
import DocumentProcessingJob, {
  DocumentProcessingJobWrapper,
} from "../../features/payslips/services/model/DocumentProcessingJob";
import { useSSEvents } from "./SSEProvider";
import { EventType, SSEEvent } from "./types";
import { SupportedFeatures } from "../../features/payslips/services/model/FeatureConfiguration";

const useDocumentsListener = (
  setDocuments: React.Dispatch<
    React.SetStateAction<DocumentProcessingJobWrapper>
  >,
  docType?: SupportedFeatures
): void => {
  const updateDocuments = useCallback(
    (event: MessageEvent) => {
      const data: SSEEvent[] = JSON.parse(event.data);

      setDocuments((docWrapper: DocumentProcessingJobWrapper) => {
        if (!docWrapper) {
          return { results: [], count: 0, pages: 0 };
        }
        let { results, count } = docWrapper;
        data.forEach((dataEvent) => {
          if (dataEvent.object_type !== EventType.Documents) {
            return;
          }

          if (docType && dataEvent.data.document_type !== docType) {
            return;
          }

          const document = { ...dataEvent.data, file_to_process: "" };
          const index = results.findIndex((doc) => doc.id === document.id);

          if (index === -1) {
            results = [document, ...results];
            count += 1;
          } else {
            // TODO - check the status of the document and handle backwards updates
            results[index] = document;
          }
        });

        return { results, count, pages: docWrapper.pages };
      });
    },
    [setDocuments]
  );

  useSSEvents(EventType.Documents, updateDocuments);
};

const useDocumentListener = (
  callBack: (doc: DocumentProcessingJob, docType: SupportedFeatures) => void,
  status: string[],
  docType?: SupportedFeatures
): void => {
  const updateDocuments = useCallback(
    (event: MessageEvent) => {
      if (!event.data) {
        return;
      }
      const data: SSEEvent[] = JSON.parse(event.data);

      data.forEach((dataEvent) => {
        if (dataEvent.object_type !== EventType.Documents) {
          return;
        }

        if (docType && dataEvent.data.document_type !== docType) {
          return;
        }

        const document = { ...dataEvent.data, file_to_process: "" };
        if (!status.includes(document.status)) {
          return;
        }

        callBack(document, dataEvent.data.document_type);
      });
    },
    [callBack, status, docType]
  );
  useSSEvents(EventType.Documents, updateDocuments);
};

export { useDocumentsListener, useDocumentListener };
